module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vleg12-e403d6bfd80816b09d381d91f88fc487.jpg";